import { render, staticRenderFns } from "./Type8b.vue?vue&type=template&id=49a2b035&"
import script from "./Type8b.vue?vue&type=script&lang=js&"
export * from "./Type8b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports